var exposeLess = {};
import genaration from '../utils/classname';
export var exposeClass = genaration(exposeLess, 'expose');